import * as React from "react";
import ConfirmPlaceholder from "./components/ConfirmPlaceholder";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  return (
    <div>
      <ConfirmPlaceholder />
    </div>
  );
};

export default App;


